import { render, staticRenderFns } from "./AppMax.vue?vue&type=template&id=fdd3c03c&"
import script from "./AppMax.vue?vue&type=script&lang=js&"
export * from "./AppMax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports